import { motion } from "framer-motion";
import { TOPICS } from "../data/config";
import { SectionTitle, StepShell } from "./Section";

export const TopicGrid = ({ selected, onSelect }) => {
  return (
    <StepShell>
      <SectionTitle kicker="Schritt 1">Was möchtest du analysieren?</SectionTitle>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {TOPICS.map((t, i) => {
          const Icon = t.icon;
          const active = selected === t.id;
          return (
            <motion.button
              key={t.id}
              data-testid={`topic-${t.id}`}
              onClick={() => onSelect(t.id)}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.45, delay: i * 0.07 }}
              whileHover={{ y: -5 }}
              whileTap={{ scale: 0.98 }}
              className={`group relative text-left rounded-2xl p-6 border transition-all duration-300 backdrop-blur-sm ${
                active
                  ? "bg-white border-[#D4AF37] glow-strong"
                  : "bg-white/70 border-[#D4AF37]/25 hover:border-[#D4AF37]/70 hover:shadow-[0_0_22px_rgba(212,175,55,0.3)]"
              }`}
            >
              <div
                className={`inline-flex items-center justify-center w-12 h-12 rounded-xl mb-4 transition-colors ${
                  active ? "bg-[#D4AF37] text-white" : "bg-[#FFF6DC] text-[#B8860B] group-hover:bg-[#FCEFC0]"
                }`}
              >
                <Icon size={24} strokeWidth={1.8} />
              </div>
              <h3 className="serif text-lg font-semibold text-[#1E3A8A]">{t.label}</h3>
              <p className="mt-1.5 text-[15px] leading-relaxed text-[#333]">{t.desc}</p>
            </motion.button>
          );
        })}
      </div>
    </StepShell>
  );
};
